<script>
  import { user } from "../../../stores/user";
  import { link } from "svelte-routing";
  import { panelController } from "../../../stores/service";
</script>

{#if $panelController.viewLogin.nav}
<aside class="main-sidebar sidebar-dark-primary elevation-4">
  <!-- Brand Logo -->
  <a use:link href="/" class="brand-link content-ala">
    <img
      src={$panelController.icons.favicon}
      alt="Ratingg"
      class="brand-image img-circle elevation-3"
      style="opacity: .8"
    />

    <span
      class="brand-text font-weight-light"
      style="text-align: center;font-family:'Croissant One';-inkscape-font-specification:'Croissant One';fill:#d0d898;fill-opacity:1;stroke-width:0.387844"
    >
      Ratingg</span
    >
  </a>

    <!-- Sidebar -->
    <div class="sidebar">
      <!-- Sidebar user (optional) -->

      {#if $user}
        <div class="user-panel mt-3 pb-3 mb-3 d-flex">
          <div class="image">
            <img
              src={$user.photoURL}
              class="img-circle elevation-2"
              alt="Login"
            />
          </div>
          <div class="info">
            <a use:link href={$panelController.viewConfiguracion.nav ? "/config/menu" : "/perfilUser"} class="d-block"
              >{$user.displayName}
            </a>
          </div>
        </div>
      {/if}

      <!-- Sidebar Menu -->
      <nav class="mt-2">
        <ul
          class="nav nav-pills nav-sidebar flex-column"
          data-widget="treeview"
          role="menu"
          data-accordion="false"
        >
          <li class="nav-header">Menú</li>
          <!-- 
        {#if $panelController.viewEvaluacion.nav}
          <li class="nav-item">
            <a use:link href="/evaluacion" class="nav-link">
              <i class="nav-icon fas fa-edit" />
              <p>Evaluacion</p>
            </a>
          </li>
        {/if} -->
          {#if $panelController.viewDashboard.nav}
            <li class="nav-item">
              <a use:link href="/dashboard" class="nav-link">
                <i class="nav-icon fas fa-tachometer-alt" />
                <p>Dashboard</p>
              </a>
            </li>{/if}
            
          {#if $panelController.viewMainRatinggs.nav}
            <li class="nav-item">
              <a use:link href="/MainAnalytics/menu" class="nav-link">
                <i class="nav-icon fas fa-th" />
                <p>Estadísticas </p>
              </a>
            </li>{/if}
          <!-- {#if $panelController.viewPanel.nav}
            <li class="nav-item">
              <a use:link href="/panel" class="nav-link">
                <i class="nav-icon fas fa-table" />
                <p>Ratinggs</p>
              </a>
            </li>{/if} -->
         <!--  {#if $panelController.viewCE.nav}
            <li class="nav-item">
              <a use:link href="/CE" class="nav-link">
                <i class="nav-icon fas fa-edit" />
                <p>Ratingg</p>
              </a>
            </li>
          {/if} -->
         <!--  {#if $panelController.viewOrdenar.nav}
            <li class="nav-item">
              <a use:link href="/Orden" class="nav-link">
                <i class="nav-icon fas fa-edit" />
                <p>Ordenar</p>
              </a>
            </li>
          {/if} -->
          {#if $panelController.viewConfiguracion.nav}
            <li class="nav-item">
              <a use:link href="/config/menu" class="nav-link">
                <i class="nav-icon fas fa-store" />
                <p>Mi restaurante</p>
              </a>
            </li>
          {:else if $panelController.viewPerfil.nav}
            <li class="nav-item">
              <a use:link href="/perfilUser" class="nav-link">
                <i class="nav-icon far fa-user" />
                <p>Perfil</p>
              </a>
            </li>
          {/if}
          <!-- {#if $panelController.viewConfiguracion.nav}
            <li class="nav-item">
              <a use:link href="/config" class="nav-link">
                <i class="nav-icon fas fa-cog" />
                <p>Configuracion</p>
              </a>
            </li>
          {/if} -->
          
          {#if $panelController.viewMesas.nav}
            <li class="nav-item">
              <a use:link href="/mesas" class="nav-link">
                <i class="nav-icon fas fa-th" />
                <p>Mesas</p>
              </a>
            </li>
          {/if}

         <!--  <li class="nav-item">
          <a use:link href="/beta" class="nav-link">
            <i class="nav-icon far fa-image" />
            <p>Beta</p>
          </a>
        </li> -->
          <!-- <li class="nav-item d-none d-sm-inline-block">
          <a use:link href="/panel" class="nav-link">Panel</a>
        </li>
        <li class="nav-item d-none d-sm-inline-block">
          <a use:link href="/CES" class="nav-link">CES</a>
        </li>
        <li class="nav-item d-none d-sm-inline-block">
          <a use:link href="/evaluacion" class="nav-link">Evaluacion</a>
        </li>
        <li class="nav-item d-none d-sm-inline-block">
          <a use:link href="/perfilUser" class="nav-link">Perfil</a>
        </li>
        <li class="nav-item d-none d-sm-inline-block">
          <a use:link href="/dashboard" class="nav-link">Dashboard</a>
        </li>
        <li class="nav-item d-none d-sm-inline-block">
          <a use:link href="/sondeosPanel" class="nav-link">Sondeos Panel</a>
        </li> -->

          <!--         <li class="nav-item">
          <a use:link href="/" class="nav-link swalDefaultSuccess">
            <i class="nav-icon fas fa-columns" />
            <p>Login</p>
          </a>
        </li> -->
        </ul>
      </nav>
      <!-- /.sidebar-menu -->
    </div>
    <!-- /.sidebar -->
</aside>
{/if}
